import "regenerator-runtime/runtime";
import axios from 'axios';
let React = require('react');

class BepensaPrices {
    async getBepensaPricesByPartNumbers(parameters){
        // To easy code.
        let operatingUnitId = 446;
        let deptoId = parameters.deptoId;
        let currencyCode = parameters.currencyCode;
        let customerId = parameters.customerId;
        let addressId = parameters.addressId || 0;
        let orderTypeCode = parameters.orderTypeCode || "PROGRAMADO";
        let cashSale = parameters.cashSale || 0; // 0 = Credit Sale, 1 = Cash Sale 
        let detail = parameters.detail; // Array of part numbers, example: [{ "partCode": "212161"}]

        let APIurl = process.env.PROTOCOL + "://" + process.env.BASE_URL + "/user/plugins/" + process.env.GATEWAY_SERVICE + "/Gateway_service.php";

        let config = {
            headers: {
                'Content-Type': 'application/json',
                'Accept' : "*/*"
            }
        };

        var result = {};

        const requestBody = {
            operatingUnitId: operatingUnitId,
            depotId: deptoId,
            currencyCode: currencyCode,
            customerId: customerId,
            addressId: addressId,
            orderTypeCode: orderTypeCode,
            cashSale: cashSale,
            detail: detail
        }

        var responseData = [];

        let gatewayRequest = {
            "strEndpointName" : "ConsultaPrecios",
            "strMethod" : "POST",
            "strJsonData" : requestBody//,
            //"arrCustomHeaders": []
        }

        console.log(" ");
        console.log('Llamando al API de Arcader ConsultaPrecios');
        console.log("Valores enviados:");
        console.log(requestBody);
        console.log(" ");

        await axios.post(APIurl, gatewayRequest, config)
        .then(response => {
            responseData = JSON.parse(response.data);
        })
        .catch(error => console.error(error));

        return responseData;
    }
}

module.exports = BepensaPrices